import { Injectable } from "@angular/core";
import { AngularFireAuth } from "@angular/fire/compat/auth";
import { BusinessIdService } from "./businessid.service";

export class SwitchUserRequest
{
    public keysToKeep: string[] = [];

    public logOutUser: boolean = false;

    public logInUser?: LoginUserRequest = undefined;

    public switchBusinessId?: SwitchBusinessIdRequest = undefined;
}

export class LoginUserRequest
{
    public username: string = "";

    public password: string = ""
}

export class SwitchBusinessIdRequest
{
    public businessId: string = "";
}


@Injectable({ providedIn: 'root' })
export class SwitchUserService
{
    constructor(private googleAuthService: AngularFireAuth, private businessIdService: BusinessIdService) { }

    // -- keep login state keys when switching users
    // needed when you switch business id (you are essentially switching users)
    // needed when you emulate a user (you are essentially switching users)
    // needed when you log in  (you are essentially switching users)
    // needed when you log out (you are essentially switching users)
    public async switchUserService(switchUserRequest: SwitchUserRequest)
    {
        if(switchUserRequest.logOutUser)
        {
            await this.googleAuthService.signOut();
            sessionStorage.clear();
            localStorage.clear();
            return;
        }

        // don't return as we want to run through the below logic too
        if(switchUserRequest.logInUser)
        {
            sessionStorage.clear();
            localStorage.clear();
            // await this.googleAuthService.setPersistence('session');
            await this.googleAuthService.signInWithEmailAndPassword(switchUserRequest.logInUser.username, switchUserRequest.logInUser.password);
        }

        // NOW ASSUME WE ARE LOGGING IN OR (SWITCHING USERS WHILE LOGGED IN - aka EMULATING A USER)

        // always keep login info
        const loginSessionStorageKey = Object.keys(sessionStorage).filter(x => x.startsWith('firebase'))[0];
        const loginSessionStorageValue = sessionStorage.getItem(loginSessionStorageKey)

        const keysToKeep = new Map<string, string>();
        switchUserRequest.keysToKeep?.forEach(e => keysToKeep.set(e, sessionStorage.getItem(e)!));
        
        sessionStorage.clear();
        localStorage.clear();

        sessionStorage.setItem(loginSessionStorageKey, loginSessionStorageValue!);

        keysToKeep.forEach((value, key) => {
            sessionStorage.setItem(key, value);
        });

        if(switchUserRequest.switchBusinessId)
        {
            sessionStorage.setItem('businessid-selected', switchUserRequest.switchBusinessId.businessId);
        }
    }

}